import base from './base'

export default {
    install(Vue){
        Vue.mixin({
            filters:{
                empty: function(value) {
                    if(!value && value !==0 && value !=='0') return '-';
                    return value;
                }
                ,toFixed1: function (value) {
                    return value.toFixed(1);
                }
                ,toFixed2: function (value) {
                    return value.toFixed(2);
                }
                ,toFixed3: function (value) {
                    return value.toFixed(3);
                }
            }
            ,methods: {
                isEmpty: base.isEmpty
                ,routerTo: base.routerTo
                ,routerToName: base.routerToName
                ,routerBack: base.routerBack
                ,dateFormat: base.dateFormat
                ,iosDislocation: base.iosDislocation
            }
        });

        Vue.prototype.$ls = base.$ls;
        Vue.prototype.$wx = base.$wx;
        Vue.prototype.$moment = base.$moment;
    }
}